export function filterActivePrograms<T extends { isVisible: boolean }>(
  programs: T[]
): T[] {
  return (programs ?? []).filter((p) => p.isVisible);
}

export function filterProgramsForTransactionEdit<
  T extends { id?: string; isVisible: boolean }
>(programs: T[], selectedProgramId?: string | null): T[] {
  return (programs ?? []).filter(
    (p) =>
      p.isVisible ||
      (selectedProgramId != null && p.id === selectedProgramId)
  );
}
